// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"d4b1a9edc01134f3e623","339":"aeaca10e31ad891978a3"}[chunkId] + ".js";
};